import { useState } from "react";
import { Heading, Text } from "../../../../components/common/typography";
import { SegmentedControl } from "../../../../components/common/segmented-control";
import { AiExtractionsTab } from "../components/ai-extractions-tab";
import { AiChatTab } from "../components/ai-chat-tab";

type Tab = "extractions" | "chat";

const TAB_OPTIONS = [
  { value: "extractions" as const, label: "Extractions" },
  { value: "chat" as const, label: "Chat" },
] as const;

export function AdminAiExtractionsPage() {
  const [tab, setTab] = useState<Tab>("extractions");

  return (
    <div className="flex min-h-full w-full flex-col bg-bgLight">
      <div className="flex flex-col gap-6 px-8 pt-8 pb-12 max-md:gap-4 max-md:px-4 max-md:pt-6">
        <div className="flex flex-col gap-1">
          <Heading variant="h2" tone="dark">AI usage</Heading>
          <Text variant="bodySm" tone="muted">
            Cost, throughput, and usage analytics across AI features.
          </Text>
        </div>

        <SegmentedControl
          options={TAB_OPTIONS}
          value={tab}
          onChange={setTab}
          aria-label="AI usage category"
          className="!gap-1 self-start"
        />

        {tab === "extractions" ? <AiExtractionsTab /> : <AiChatTab />}
      </div>
    </div>
  );
}
